import {
  Box,
  Grid,
  styled,
  Typography,
  Checkbox,
  ListItem,
  List,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import candidateActions from "../../redux/candidate/actions";
import GovernmentImage from "../../assets/images/Government.png";
import CetImage from "../../assets/images/Cet.png";
import { MdOutlineModeEdit } from "react-icons/md";
import Cookies from "js-cookie";
import dayjs from "dayjs";

export default function PrintApplicationForm() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState("");
  const [CheckboxValue, setCheckBoxValue] = useState(false);

  const { candidateid, courseid, coursename, amount } = location.state || {};
  const fullCandidateDetails = useSelector((state) => state.candidateReducer.fullCandidateDetails);
  const uploadDetails = useSelector((state) => state.candidateReducer.uploadDetails );
  

  useEffect(() => {
    if (!isLoading && fullCandidateDetails && uploadDetails.length >= 3) {
      const hasPhoto = uploadDetails.find(
        (detail) => detail.documenttype === 1
      );
      const hasSignature = uploadDetails.find(
        (detail) => detail.documenttype === 2
      );
      const hasDocument = uploadDetails.find(
        (detail) => detail.documenttype === 3
      );

      if (hasPhoto && hasSignature && hasDocument) {
        window.print();
        navigate("/mhcet/search-candidate", { replace: true });
      }
    }
  }, [isLoading, fullCandidateDetails, uploadDetails, navigate]);

  useEffect(() => {
    if (candidateid) {
      if (!fullCandidateDetails || !uploadDetails) {
        dispatch({
          type: candidateActions.GET_FULL_CANDIDATE_DETAILS,
          payload: { id: candidateid },
        });
        dispatch({
          type: candidateActions.GET_UPLOAD_PERSONAL_DETAILS,
          payload: { id: candidateid },
        });
      }
    }
  }, [candidateid, dispatch]);

  useEffect(() => {
    if (fullCandidateDetails && uploadDetails.length >= 3) {
      setIsLoading(false);
    }
  }, [fullCandidateDetails, uploadDetails]);

  useEffect(() => {
    if (uploadDetails && uploadDetails.length >= 3) {
      const documentDetail = uploadDetails.find(
        (detail) => detail.documenttype === 3
      );

      if (documentDetail && documentDetail.document) {
        try {
          const base64Data =
            documentDetail.document.split(",")[1] || documentDetail.document;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
          return () => URL.revokeObjectURL(url);
        } catch (error) {
          console.error("Error decoding Base64 string:", error);
        }
      }
    }
  }, [uploadDetails]);

  const handleCheckbox = (e) => {
    const checked = e.target.checked;
    setCheckBoxValue(checked);
    setError("");
  };

  const style = styled({
    fontStyle: {
      fontWeight: 600,
    },
  });
  const classes = style();

  const status = fullCandidateDetails?.status;
  const isPaid = fullCandidateDetails?.ispaid;

  return (
    <Box
      //   p={3}
      style={{
        minHeight: "50vh",
        backgroundColor: "#fff",
        // borderRadius: "8px",
        border: "2px solid #000",
      }}
      // ref={targetRef}
    >
      <Box
        style={{
          borderBottom: "1px solid #000",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Online Registration For {coursename}
        </Typography>
        <Typography variant="h6" fontWeight={600}>
          Application Form
        </Typography>
      </Box>
      <Grid
        container
        //   p={3}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderBottom: "1px solid #000",
        }}
      >
        <Grid item sx={{ width: "100px" }}>
          <img
            style={{ height: "100px", width: "auto" }}
            src={CetImage}
            alt="image"
          />
        </Grid>
        <Grid
          item
          // md={8}

          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            flex: 1,
          }}
        >
          <img
            style={{ height: "75px", width: "auto" }}
            src={GovernmentImage}
            alt="image"
          />
          <Typography variant="h5" fontWeight={600}>
            GOVERNMENT OF MAHARASHTRA
          </Typography>
          <Typography variant="h5" fontWeight={600}>
            STATE COMMON ENTRANCE TEST CELL, MAHARASHTRA STATE
          </Typography>
          <Typography variant="p" fontWeight={600}>
            8th Floor, New Excelsior Building, A.K.Nayak Marg, Fort,
            Mumbai-400001. (M.S.)
          </Typography>
          <Typography variant="p" sx={{ marginTop: 1 }} fontWeight={600}>
            Application Form for Online Registration For {coursename}
          </Typography>
          {/* <Typography>APPLICATION FORM</Typography> */}
        </Grid>
        <Grid
          item
          sx={{ display: "flex", justifyContent: "flex-end", width: "100px" }}
        >
          <img
            style={{ height: "100px", width: "auto" }}
            src={CetImage}
            alt="image"
          />
        </Grid>
      </Grid>
      <Box sx={{ borderBottom: "1px solid #000" }}>
        {location.pathname + location.search ===
          "/mhcet/course-registration?page=printapplication" &&
          candidateid !== "" && (
            <Typography
              variant="h6"
              sx={{
                textWrap: "wrap",
                fontWeight: "bold",
                color: "#000",
                textAlign: "center",
              }}
            >
              Application No : {candidateid} {"  "}
              Version No : 1
            </Typography>
          )}
      </Box>
      <Grid container sx={{ width: "100%" }}>
        <Grid item xs={12}>
          <Box
            sx={{
              borderBottom: "1px solid #000",
            }}
          >
            <Box>
              <Typography variant="p">Personal Details</Typography>
            </Box>
          </Box>

          <Grid container xs={12} sx={{ minWidth: "700px" }}>
            <Grid item md={7} sx={{ width: "450px" }}>
              <Grid container xs={12}>
                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Candidate’s Full name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.candidatename}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Father’s Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.fathername}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Mother’s Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.mothername}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Gender
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.gender}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Marital Status
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.maritalstatusid) === 1
                      ? "Married"
                      : parseInt(fullCandidateDetails?.maritalstatusid) === 2
                      ? "Unmarried"
                      : "-"}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Spouse Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.length > 0 &&
                      (fullCandidateDetails?.spousename || "-")}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Date of Birth
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.dob &&
                      dayjs(fullCandidateDetails?.dob).format("DD-MM-YYYY")}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Religion
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.religion}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Region
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.region}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Mother Tongue
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.mothertongue}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Annual Family Income
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.familyincome}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    {" "}
                    Nationality
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.nationality}
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={7}
                  sx={{ border: "1px solid #000", width: "250px" }}
                >
                  <Typography sx={{ fontSize: 12, textAlign: "right" }}>
                    {" "}
                    {coursename} Application Fee Paid (&#x20B9;)
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={5}
                  sx={{ border: "1px solid #000", width: "200px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {amount} /-
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={5} sx={{ border: "1px solid #000", width: "250px" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                {uploadDetails[0]?.fileurl && (
                  <img
                    style={{
                      width: "120px",
                      height: "auto",
                      aspectRatio: "3/4",
                    }}
                    src={uploadDetails[0]?.fileurl}
                    alt="Photo"
                  />
                )}

                {uploadDetails[1]?.fileurl && (
                  <img
                    style={{
                      width: "120px",
                      height: "auto",
                      backgroundColor: "whitesmoke",
                    }}
                    src={uploadDetails[1]?.fileurl}
                    alt="Signature"
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={6}>
            <Box
              sx={{
                //   height: "48px",
                //   backgroundColor: "#EDEDED",
                //   display: "flex",
                //   alignItems: "center",
                //   justifyContent: "space-between",
                border: "1px solid #000",
                // width: "348px",
                // borderRadius: "8px 8px 0px 0px",
              }}
            >
              <Box>
                <Typography sx={{ fontSize: 18 }}>Permanent Address</Typography>
              </Box>
            </Box>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "148px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  {" "}
                  Address Line 1
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "200px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.paddressline1}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "148px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Address Line 2
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "200px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.paddressline2}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "148px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Address Line 3
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "200px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.length > 0 &&
                    (fullCandidateDetails?.paddressline3 || "-----")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  State
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "100px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.pstate}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  District
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "100px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.pdistrict}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Taluka
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "100px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.ptaluka}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Village
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "100px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.pvillage}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Pin code
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "274px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.ppincode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Box
              sx={{
                border: "1px solid #000",
                // width: "350px",

                // borderRadius: "8px 8px 0px 0px",
              }}
            >
              <Box>
                <Typography sx={{ fontSize: 18 }}>
                  Address for Correspondence
                </Typography>
              </Box>
            </Box>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "148px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  {" "}
                  Address Line 1
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "200px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.caddressline1}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "148px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Address Line 2
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "200px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.caddressline2}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "148px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Address Line 3
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "200px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.length > 0 &&
                    (fullCandidateDetails?.caddressline3 || "-----")}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  State
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "100px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.cstate}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  District
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "100px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.cdistrict === null
                    ? "Not Applicable"
                    : fullCandidateDetails?.cdistrict}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Taluka
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "100px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.ctaluka === null
                    ? "Not Applicable"
                    : fullCandidateDetails?.ctaluka}
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Village
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "100px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.cvillage === null
                    ? "Not Applicable"
                    : fullCandidateDetails?.cvillage}
                </Typography>
              </Grid>
            </Grid>
            <Grid container md={12}>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "74px" }}
              >
                <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                  Pin code
                </Typography>
              </Grid>
              <Grid
                item
                md={6}
                sx={{ border: "1px solid #000", width: "274px" }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {fullCandidateDetails?.cpincode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={6} sx={{ border: "1px solid #000" }}>
            <Box sx={{ width: "346px" }}>
              <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                Telephone No
              </Typography>
            </Box>
          </Grid>
          <Grid item md={6} sx={{ border: "1px solid #000" }}>
            <Box sx={{ width: "346px" }}>
              <Typography
                sx={{
                  fontSize: 12,
                  px: 1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                {fullCandidateDetails?.phoneno}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12}>
          <Box
            sx={{
              border: "1px solid #000",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>
                Domicile and Category Deatils
              </Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            {fullCandidateDetails?.ismhcandidate && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Are You Domiciled In The State Of Maharastra
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.ismhcandidate) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.ismhcandidate) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.category && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Category
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.category}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.castename && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.castename}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.caste && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste To Which You Belong
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.caste}
                  </Typography>
                </Grid>
              </>
            )}
            {fullCandidateDetails?.castecertificatestatus && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Do You Possess Caste Certificate
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.castecertificatestatus) ===
                    1
                      ? "Available"
                      : parseInt(
                          fullCandidateDetails?.castecertificatestatus
                        ) === 2
                      ? "Applied But Not Received"
                      : parseInt(
                          fullCandidateDetails?.castecertificatestatus
                        ) === 3
                      ? "Not Applied"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}

            {((fullCandidateDetails?.castevaliditystatus !== null &&
              fullCandidateDetails?.castevaliditystatus !== undefined &&
              fullCandidateDetails?.castevaliditystatus !== "") ||
              fullCandidateDetails?.castevaliditystatus === 0) && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Do You Possess Caste/Tribe Validity Certificate
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.castevaliditystatus) === 1
                      ? "Available"
                      : parseInt(fullCandidateDetails?.castevaliditystatus) ===
                        2
                      ? "Applied But Not Received"
                      : parseInt(fullCandidateDetails?.castevaliditystatus) ===
                        0
                      ? "Not Applied"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.castevaliditycertificateno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste Validity Certificate No
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.castevaliditycertificateno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.cvcapplicationno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste/Tribe Validity Certificate Application Number
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.cvcapplicationno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.cvcapplicationdate && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste/Tribe Validity Certificate Application Date
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.cvcapplicationdate}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.cvcauthority && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste/Tribe Validity Certificate Issuing Authority Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.cvcauthority}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.cvcdistrict && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste/Tribe Validity Certificate Issuing District
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.cvcdistrict}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.cvcname && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Candidate Name As Per Caste Certificate
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.cvcname}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.castecertificateno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste Certificate/Receipt No
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.castecertificateno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.castecertificatereceiptno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste Certificate Receipt No
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.castecertificatereceiptno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.castecertificateappdate && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Caste Certificate Application Date
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.castecertificateappdate}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.appliedforews && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Do You Want To Apply For EWS
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.appliedforews) === 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.appliedforews) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.ewscertificatestatus !== null &&
              (fullCandidateDetails?.ewscertificatestatus === 0 ||
                fullCandidateDetails?.ewscertificatestatus === 1 ||
                fullCandidateDetails?.ewscertificatestatus === 2) && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      EWS Certificate
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.ewscertificatestatus) ===
                      1
                        ? "Available"
                        : parseInt(
                            fullCandidateDetails?.ewscertificatestatus
                          ) === 2
                        ? "Not Available"
                        : parseInt(
                            fullCandidateDetails?.ewscertificatestatus
                          ) === 0
                        ? "Applied But Not Received"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

            {fullCandidateDetails?.ewsapplicationno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    EWS Certificate Application Number
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.ewsapplicationno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.ewsapplicationdate && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    EWS Certificate Application Date
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.ewsapplicationdate}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.ewsdistrict && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    EWS Certificate Issuing District
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.ewsdistrict}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.ewstaluka && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    EWS Certificate Issuing Taluka
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.ewstaluka}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.nclstatus && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Do You Have Non Creamy Layer Certificate
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.nclstatus) === 1
                      ? "Available"
                      : parseInt(fullCandidateDetails?.nclstatus) === 2
                      ? "Applied But Not Received"
                      : parseInt(fullCandidateDetails?.nclstatus) === 3
                      ? "Not Applied"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.nclapplicationno && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Non Creamy Layer Certificate Application Number
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.nclapplicationno}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.nclapplicationdate && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Non Creamy Layer Certificate Application Date
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.nclapplicationdate}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.nclauthority && (
              <>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "74px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    NCL Authority
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={3}
                  xs={3}
                  sx={{ border: "1px solid #000", width: "100px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.nclauthority}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          {/* {(fullCandidateDetails?.isminority ||
              fullCandidateDetails?.linguisticminority ||
              fullCandidateDetails?.religiousminority) && (
              <>
                <Box
                  sx={{
                    border: "1px solid #000",
                    marginTop: ".1rem",
                    width: "100%",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: 18 }}>
                      Minority Information
                    </Typography>
                  </Box>
                </Box>
              </>
            )} */}
          <Grid container md={12}>
            {fullCandidateDetails?.isdisability && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Are You Person With Disability
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.isdisability) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.isdisability) == 0
                      ? "No"
                      : "---"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.pwdtype && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Type Of Disability
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.pwdtype}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.pwdsubtype && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    PWD Sub Type
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.pwdsubtype}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.isextratime && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Require Extra Time
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.isextratime) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.isextratime) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.isscribe && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Require Scribe
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.isscribe) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.isscribe) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          <Grid container md={12}>
            {fullCandidateDetails?.isminority && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Do You Belong To Minority Category
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.isminority) === 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.isminority) === 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.linguisticminority && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Linguistic Minority
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.linguisticminority}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.religiousminority && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Religious Minority
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.religiousminority}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>

          {(fullCandidateDetails?.isorphan ||
            fullCandidateDetails?.orphantype) && (
            <>
              <Box
                sx={{
                  // border: "1px solid #000",
                  // marginTop: ".1rem",
                  width: "100%",
                }}
              >
                <Box>
                  <Typography sx={{ fontSize: 18 }}>
                    Orphan Information
                  </Typography>
                </Box>
              </Box>
            </>
          )}
          <Grid container md={12}>
            {fullCandidateDetails?.isorphan && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Are You Orphan
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.isorphan) == 1
                      ? "Yes"
                      : parseInt(fullCandidateDetails?.isorphan) == 0
                      ? "No"
                      : "----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.orphantype && (
              <>
                <Grid item md={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "right",
                      width: "348px",
                    }}
                  >
                    Orphan Type
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.orphantype}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          <Grid container md={12}>
            {(fullCandidateDetails?.issports ||
              fullCandidateDetails?.sportsparticipation ||
              fullCandidateDetails?.sportsparticipationyear ||
              fullCandidateDetails?.sportsrank ||
              fullCandidateDetails?.sports ||
              fullCandidateDetails?.sportsbody ||
              fullCandidateDetails?.isphysicaleducation ||
              fullCandidateDetails?.isteachingexperience ||
              fullCandidateDetails?.isappliedforelct ||
              fullCandidateDetails?.isappliedforksu ||
              fullCandidateDetails?.isappliedforspecialeducation ||
              fullCandidateDetails?.specialeducationmethods) && (
              <>
                <Box
                  sx={{
                    // border: "1px solid #000",
                    // marginTop: ".1rem",
                    width: "100%",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: 18 }}>
                      Sports information
                    </Typography>
                  </Box>
                </Box>
              </>
            )}
            <Grid container md={12}>
              {fullCandidateDetails?.issports && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Is Sports
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.issports) === 1
                        ? "Yes"
                        : "No"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.sportsparticipation && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Sports Participation Level
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.sportsparticipation}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.sportsparticipationyear && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Sports Participation Year
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.sportsparticipationyear}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.sportsrank && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Sports Rank
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.sportsrank}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.sports && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Sports Name
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.sports}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.sportsbody && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Sports Body
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.sportsbody}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.isphysicaleducation && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Is Studied Physical Education
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.isphysicaleducation) == 1
                        ? "Yes"
                        : parseInt(fullCandidateDetails?.isphysicaleducation) ==
                          0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.isteachingexperience && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Is Teaching Experience
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.isteachingexperience) == 1
                        ? "Yes"
                        : parseInt(
                            fullCandidateDetails?.isteachingexperience
                          ) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.isappliedforelct && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Is Applied For ELCT
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.isappliedforelct) == 1
                        ? "Yes"
                        : parseInt(fullCandidateDetails?.isappliedforelct) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.isappliedforksu && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Is Applied For KSU
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                      }}
                    >
                      {parseInt(fullCandidateDetails?.isappliedforksu) == 1
                        ? "Yes"
                        : parseInt(fullCandidateDetails?.isappliedforksu) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.isappliedforspecialeducation && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Is Applied For Special Education
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                      }}
                    >
                      {parseInt(
                        fullCandidateDetails?.isappliedforspecialeducation
                      ) == 1
                        ? "Yes"
                        : parseInt(
                            fullCandidateDetails?.isappliedforspecialeducation
                          ) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}

              {fullCandidateDetails?.specialeducationmethods && (
                <>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "74px" }}
                  >
                    <Typography
                      sx={{ fontSize: 12, px: 1, textAlign: "right" }}
                    >
                      Special Education Methods
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={3}
                    sx={{ border: "1px solid #000", width: "100px" }}
                  >
                    <Typography
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                      }}
                    >
                      {parseInt(
                        fullCandidateDetails?.specialeducationmethods
                      ) == 1
                        ? "Yes"
                        : parseInt(
                            fullCandidateDetails?.specialeducationmethods
                          ) == 0
                        ? "No"
                        : "----"}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>

            <Box
              sx={{
                border: "1px solid #000",
                marginTop: ".1rem",
                width: "100%",
              }}
            >
              {/* <Box>
                <Typography sx={{ fontSize: 18 }}>
                  Category information
                </Typography>
              </Box> */}
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {(fullCandidateDetails?.sscpassedfromindia ||
            fullCandidateDetails?.sscschoolstate ||
            fullCandidateDetails?.sscschooldistrict ||
            fullCandidateDetails?.sscschooltaluka ||
            fullCandidateDetails?.sscpassingyear ||
            fullCandidateDetails?.sscboard ||
            fullCandidateDetails?.sscschoolname ||
            fullCandidateDetails?.ssctotalpercentage) && (
            <>
              <Box
                sx={{
                  border: "1px solid #000",
                }}
              >
                <Box>
                  <Typography sx={{ fontSize: 18 }}>
                    Qualification Details
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  border: "1px solid #000",
                  marginTop: ".1rem",
                }}
              >
                <Box>
                  <Typography sx={{ fontSize: 18 }}>SSC Information</Typography>
                </Box>
              </Box>
            </>
          )}

          <Grid container md={12}>
            {fullCandidateDetails?.sscpassedfromindia && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    SSC Passed From India
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.sscpassedfromindia == 1
                      ? "Yes"
                      : fullCandidateDetails?.sscpassedfromindia == 0
                      ? "No"
                      : "---"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.sscschoolstate && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    SSC School State
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.sscschoolstate}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.sscschooldistrict && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    SSC School District
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.sscschooldistrict}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.sscschooltaluka && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    SSC School Taluka
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.sscschooltaluka}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.sscpassingyear && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    SSC/Equivalent Passing Year
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.sscpassingyear}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.sscboard && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    SSC/Equivalent Board
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.sscboard}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.sscschoolname && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    SSC School Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.sscschoolname}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.ssctotalpercentage && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    SSC/Equivalent Total Percentage
                  </Typography>
                </Grid>

                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.ssctotalpercentage}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          {(fullCandidateDetails?.hsccollegestate ||
            fullCandidateDetails?.hsccollegedistrict ||
            fullCandidateDetails?.hsccollegetaluka ||
            fullCandidateDetails?.hsccollegename ||
            fullCandidateDetails?.hscmarktype ||
            fullCandidateDetails?.hscmarksobtained ||
            fullCandidateDetails?.hscmarksoutof ||
            fullCandidateDetails?.hscpercentage ||
            fullCandidateDetails?.hscenglishmarksobtained ||
            fullCandidateDetails?.hscenglishmarksoutof ||
            fullCandidateDetails?.hscenglishpercentage ||
            fullCandidateDetails?.hscpassingyear ||
            fullCandidateDetails?.hscboard) && (
            <Box
              sx={{
                // border: "1px solid #000",
                marginTop: ".1rem",
              }}
            >
              <Box>
                <Typography sx={{ fontSize: 18 }}>HSC Information</Typography>
              </Box>
            </Box>
          )}
          <Grid container md={12}>
            {fullCandidateDetails?.hsccollegestate && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC College State
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hsccollegestate}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hsccollegedistrict && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC College District
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hsccollegedistrict}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hsccollegetaluka && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC College Taluka
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hsccollegetaluka}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hscpassingyear && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC Passing Year
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hscpassingyear}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hscboard && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC Board
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hscboard}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hsccollegename && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC College Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hsccollegename}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hscmarktype && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Marks Type
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.hscmarktype) === 1
                      ? "CGPA"
                      : parseInt(fullCandidateDetails?.hscmarktype) === 2
                      ? "Percentage"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}
            {fullCandidateDetails?.hscmarksobtained && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC Marks Obtained
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hscmarksobtained}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hscmarksoutof && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC Marks Out Of
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hscmarksoutof}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hscpercentage && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC Percentage
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hscpercentage}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hscenglishmarksobtained && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC English Marks Obtained
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hscenglishmarksobtained}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hscenglishmarksoutof && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC English Marks Out Of
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hscenglishmarksoutof}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.hscenglishpercentage && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    HSC English Percentage
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.hscenglishpercentage}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>

          {(fullCandidateDetails?.eligibilityqualification ||
            fullCandidateDetails?.graduationstatus ||
            fullCandidateDetails?.graduationpassingyear ||
            fullCandidateDetails?.graduationbranch ||
            fullCandidateDetails?.graduationmarktype ||
            fullCandidateDetails?.graduationmarksobtained ||
            fullCandidateDetails?.graduationmarksoutof ||
            fullCandidateDetails?.graduationpercentage ||
            fullCandidateDetails?.awardedclass ||
            fullCandidateDetails?.gradudationduration) && (
            <Box
              sx={{
                // border: "1px solid #000",
                marginTop: ".1rem",
              }}
            >
              <Box>
                <Typography sx={{ fontSize: 18 }}>
                  Graduation Information
                </Typography>
              </Box>
            </Box>
          )}
          <Grid container md={12}>
            {fullCandidateDetails?.eligibilityqualification && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Eligiblity Qualification
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.eligibilityqualification}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.graduationstatus && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Graduation Status
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.graduationstatus == 1
                      ? "Appearing"
                      : fullCandidateDetails?.graduationstatus == 2
                      ? "Passed"
                      : fullCandidateDetails?.graduationstatus == 0
                      ? "Not Applicable"
                      : "---"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.graduationpassingyear && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Graduation Passing Year
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.graduationpassingyear}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.graduationbranch && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Graduation Branch Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.graduationbranch}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.graduationmarktype && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Graduation Marks Type
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {parseInt(fullCandidateDetails?.graduationmarktype) == 1
                      ? "Percentage"
                      : parseInt(fullCandidateDetails?.graduationmarktype) === 2
                      ? "CGPA"
                      : "-----"}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.graduationmarksobtained && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Graduation Marks Obtained
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.graduationmarksobtained}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.graduationmarksoutof && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Graduation Marks Out Of
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.graduationmarksoutof}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.graduationpercentage && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Graduation Percentage
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.graduationpercentage}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.awardedclass && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Awarded Class Name
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.awardedclass}
                  </Typography>
                </Grid>
              </>
            )}

            {fullCandidateDetails?.gradudationduration && (
              <>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Graduation Duration
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={6}
                  sx={{ border: "1px solid #000", width: "348px" }}
                >
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.gradudationduration}
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          {(fullCandidateDetails?.subjectgroup ||
            fullCandidateDetails?.examstate ||
            fullCandidateDetails?.language ||
            fullCandidateDetails?.preference1district ||
            fullCandidateDetails?.preference2district ||
            fullCandidateDetails?.preference3district ||
            fullCandidateDetails?.preference4district) && (
            <>
              <Box
                sx={{
                  border: "1px solid #000",
                }}
              >
                <Box>
                  <Typography sx={{ fontSize: 18 }}>
                    Exam Centre Selection Details
                  </Typography>
                </Box>
                {location.search !== "?page=printapplication" && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate(
                        `/${Cookies.get(
                          "mhet_cnd_project"
                        )}/course-registration?page=examinationdetails`,
                        {
                          state: {
                            courseid: courseid,
                            coursename: coursename,
                            status: status >= 5 ? 1 : 0,
                          },
                        }
                      )
                    }
                  >
                    <MdOutlineModeEdit size={20} /> &nbsp;
                    <Typography sx={{ fontSize: 18 }}>Edit</Typography>
                  </Box>
                )}
              </Box>
            </>
          )}
          {fullCandidateDetails?.subjectgroup && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Subject Group for Exam
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.subjectgroup}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.examstate && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Examination Centre State
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.examstate}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.language && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Language / Medium of the Question Paper
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  {fullCandidateDetails?.language?.map((val, i) => (
                    <Typography
                      key={i}
                      sx={{
                        fontSize: 12,
                        px: 1,
                        textAlign: "left",
                        color: "black",
                        fontWeight: 500,
                        textAlign: "left",
                      }}
                    >
                      {fullCandidateDetails?.language.length > 1 && `${i + 1}.`}
                      {val}
                    </Typography>
                  ))}
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.preference1district && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Examination Center District at Preference Number 1
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.preference1district}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.preference2district && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Examination Center District at Preference Number 2
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.preference2district}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.preference3district && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Examination Center District at Preference Number 3
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.preference3district}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {fullCandidateDetails?.preference4district && (
            <>
              <Grid container md={12}>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography sx={{ fontSize: 12, px: 1, textAlign: "right" }}>
                    Examination Center District at Preference Number 4
                  </Typography>
                </Grid>
                <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      px: 1,
                      textAlign: "left",
                      color: "black",
                      fontWeight: 500,
                      textAlign: "left",
                    }}
                  >
                    {fullCandidateDetails?.length > 0 &&
                      (fullCandidateDetails?.preference4district || "-----")}
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}

          {/* <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Post Graduation Information</Typography>
            </Box>
          </Box> */}
          {/* <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Document For Type A
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Document Of
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                CET Exam Name
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Whether Pass Institution Situated MH?
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
             <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                PF Graduation Date
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Internship Training Date
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                MH Council Registration
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Re Council Registration
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
             <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Already Admitted
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
                      <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                College Name
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
                      <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                University Name
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
                      <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid> */}
          {/* <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>First Year Marks</Typography>
            </Box>
          </Box> */}
          {/* <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                FY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                FY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                FY Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                FY No Of Attempts
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid> */}
          {/* <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Second Year Marks</Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                SY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                SY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                SY Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                SY No Of Attempts
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid>
          <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Third Year Marks</Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                TY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                TY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                TY Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                TY No Of Attempts
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid>
          <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Fourth Year Marks</Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                FourY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                FourY Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                FourY Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                FourY No Of Attempts
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid>
          <Box
            
            sx={{
              border:'1px solid #000',
              marginTop:".1rem"
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Aggregate Marks</Typography>
            </Box>
          </Box>
          <Grid container md={12}>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Aggregate Marks Obtained
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Aggregate Marks Out Of
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
              
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{ fontSize: 12,
                px:1, textAlign: "left",  }}
              >
                Aggregate Percentage
              </Typography>
            </Grid>
            <Grid
              item
              md={3}
              
              xs={12}
              sx={{ border: "1px solid #000" }}
            >
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                
              </Typography>
            </Grid>
          </Grid> */}
        </Grid>

        {/* <Grid item md={12} xs={12}>
          <Box
            sx={{
              border: "1px solid #000",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>
                Photograph and Signature
              </Typography>
            </Box>
            {location.search !== "?page=printapplication" && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() =>
                  navigate(
                    `/${Cookies.get(
                      "mhet_cnd_project"
                    )}/registration?page=uploads`,
                    {
                      state: {
                        courseid: courseid,
                        coursename: coursename,
                        status: status >= 5 ? 1 : 0,
                      },
                    }
                  )
                }
              >
                <MdOutlineModeEdit size={20} /> &nbsp;
                <Typography sx={{ fontSize: 18 }}>Edit</Typography>
              </Box>
            )}
          </Box>
          <Grid container md={12}>
            <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "center",
                  color: "black",
                  fontWeight: 500,
                }}
              >
                Photograph
              </Typography>
            </Grid>
            <Grid item md={6} xs={6} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",
                  color: "black",
                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                Signature
              </Typography>
            </Grid>
          </Grid>
          <Grid container md={12}>
            <Grid
              item
              md={6}
              xs={6}
              sx={{
                border: "1px solid #000",
                height: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                style={{ height: "140px", width: "auto" }}
                src={fullCandidateDetails?.document}
                alt="photo"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={6}
              sx={{
                border: "1px solid #000",
                height: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                style={{ height: "53px", width: "auto" }}
                src={fullCandidateDetails?.document}
                alt="signatute"
              />
            </Grid>
          </Grid>
        </Grid>
*/}
        <Grid item md={12} xs={12}>
          <Grid
            container
            // md={12}
            // xs={12}

            sx={{}}
          >
            <Box>
              <Typography sx={{ fontSize: 18 }}>Document Uploaded</Typography>
            </Box>
          </Grid>
          <Grid container md={12}>
            <Grid item md={2} xs={2} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 12,
                  px: 1,
                  textAlign: "center",

                  fontWeight: 500,
                }}
              >
                S.No
              </Typography>
            </Grid>
            <Grid item md={10} xs={10} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 12,
                  px: 1,
                  textAlign: "left",

                  fontWeight: 500,
                  textAlign: "center",
                }}
              >
                Document Name
              </Typography>
            </Grid>
          </Grid>
          <Grid container md={12}>
            <Grid item md={2} xs={2} sx={{ border: "1px solid #000" }}>
              <Typography
                sx={{
                  fontSize: 12,
                  px: 1,
                  textAlign: "center",
                  color: "black",
                  fontWeight: 500,
                }}
              >
                1
              </Typography>
            </Grid>
            <Grid item md={10} xs={10} sx={{ border: "1px solid #000" }}>
            {uploadDetails.length > 2 && uploadDetails[2]?.documentname && (
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  {uploadDetails[2]?.documentname}
                </Typography>
              )}
            </Grid>
            {/* <Grid
              item
              md={6}
              xs={6}
              sx={{
                border: "1px solid #000",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                component="a"
                sx={{
                  fontSize: 12,
                  px:1,
                  textAlign: "left",

                  fontWeight: 500,
                  textAlign: "center",
                  cursor: "pointer",
                  ":hover": {
                    textDecoration: "underline",
                  },
                }}
                target="_blank"
                href={pdfUrl}
              >
                View
              </Box>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid item md={12} xs={12} sx={{ border: "1px solid #000" }}>
          <Box
            sx={{
              width: "696px",
            }}
          >
            <Box>
              <Typography sx={{ fontSize: 12, px: 1, fontWeight: 600 }}>
                Note :
              </Typography>
              <List
                sx={{
                  listStyleType: "disc",
                  pl: 3,
                  fontSize: 12,
                  color: "#e6393f",
                }}
              >
                <ListItem sx={{ display: "list-item" }}>
                  You are required to Upload the Caste Certificate clearly
                  mentioning the Category of the Candidate and also the remarks
                  that the Caste is recognised as backward class in the State of
                  Maharashtra at the time of Centralised Admission Process(CAP
                  2024).
                </ListItem>

                <ListItem sx={{ display: "list-item" }}>
                  You are required to Upload the Caste / Tribe Validity
                  Certificate in the name of the Candidate, issued by the caste
                  validity committee of Maharashtra State at the time of
                  Centralised Admission Process(CAP 2024).
                </ListItem>
              </List>
            </Box>
          </Box>
          <Box
            sx={{
              border: "1px solid #000",
              width: "696px",
            }}
          >
            <Typography
              sx={{
                fontSize: 15,
                px: 1,
                textAlign: "left",
                color: "black",
                fontWeight: 600,
                textAlign: "left",
              }}
            >
              Declaration:
            </Typography>
            <Typography
              sx={{
                fontSize: 12,
                px: 1,
                textAlign: "left",
                color: "black",
                fontWeight: 500,
                textAlign: "left",
              }}
            >
              I {fullCandidateDetails?.candidatename} have downloaded the
              Information Brochure of {coursename} and have read all the rules
              for appearing the CET and on understanding these Rules, I have
              filled this Application Form for appearing to {coursename} for the
              Academic Year 2024-25. This information given by me in this
              application is true to the best of my knowledge & belief. If at
              later stage, it is found that I have furnished wrong informatation
              and/or submitted false certificate(s), I am aware that my
              admission stands cancelled and fees paid by me will be forfeited.
              Further I will be subject to legal and/or penal action as per the
              provisions of the law.
            </Typography>
          </Box>
          <Grid container sx={{ width: "598px" }}>
            <Grid item md={8} xs={8}>
              <Box
                sx={{
                  border: "1px solid #000",

                  width: "398px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  Date :
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #000",

                  width: "398px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  Last Modified By :
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #000",

                  width: "398px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  Last Modified On :
                </Typography>
              </Box>
              <Box
                sx={{
                  border: "1px solid #000",

                  width: "398px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    px: 1,
                    textAlign: "left",
                    color: "black",
                    fontWeight: 500,
                    textAlign: "left",
                  }}
                >
                  Printed On :
                </Typography>
              </Box>
            </Grid>
            <Grid item md={4} xs={4}>
              <Box
                sx={{
                  border: "1px solid #000",
                  display: "grid",
                  placeItems: "center",
                  width: "298px",
                  height: "100%",
                }}
              >
                {uploadDetails[1]?.fileurl && (
                  <img
                    style={{
                      width: "75px",
                      height: "auto",
                      aspectRatio: "4/3",
                    }}
                    src={uploadDetails[1]?.fileurl}
                    alt="Signature"
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
